import * as service from '../agent/routers/cliJsCode/service';
import { TimeoutError } from '../errors';
import { featureFlagsService } from '../commons/featureFlagsService';
import type { ProjectData } from '../runOptions';
import type { WebDriver } from '../player/webdriver';
import type { LauncherDriverType } from '../player/chromeLauncherTestPlayer';
import type { SerializableRemoteObject } from 'clickim/src/background/stepActions/remoteStepActionMixin';

function isExceedingMaxResultSize(data: { result: { resultValue: any; exports: object; exportsTest: object; exportsGlobal: object }; tstConsoleLogs: service.ConsoleItem[] }, project: ProjectData) {
    try {
        const shouldEnforceMaxSize = project.defaults.enforceMaximumJsResultSize;
        const maximumJsResultSize = featureFlagsService.flags.maximumJsResultSize.getValue();
        const dataSizeExceeded = JSON.stringify(data).length > maximumJsResultSize;
        if (!shouldEnforceMaxSize) {
            return false;
        }
        return dataSizeExceeded;
    } catch (e) {
        return false;
    }
}

export const run = async (browser: WebDriver | LauncherDriverType, step: SerializableRemoteObject, projectData: ProjectData) => {
    const {
        code, stepId, incomingParams, context, testResultId, retryIndex, stepResultId, runTimeout, fileDataUrl, s3filepath,
    } = step.data;
    try {
        const data = await service.runCodeWithPackages(code, stepId, incomingParams, context, testResultId, retryIndex, stepResultId, runTimeout, fileDataUrl, s3filepath);
        if (data && isExceedingMaxResultSize({ result: data.result, tstConsoleLogs: data.tstConsoleLogs }, projectData)) {
            return {
                code: 'js-result-max-size-exceeded',
                success: false,
            };
        }
        return { data, success: true };
    } catch (err) {
        if (err instanceof TimeoutError) {
            throw new Error('Timeout while running action');
        }
        throw err;
    }
};
